<span class="mr-1">{{ currentYear }} RiPSIM Technologies Inc.</span>
